// extracted by mini-css-extract-plugin
export var masonryGrid = "News-module--masonry-grid--vqLkJ";
export var masonryGridColumn = "News-module--masonry-grid-column--Lz5fu";
export var link = "News-module--link--3bgD+";